var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowRightMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15V17H1V15H19ZM4.596 0.903992L6.01 2.31799L2.828 5.49999L6.01 8.68199L4.596 10.096L0 5.49999L4.596 0.903992ZM19 7.99999V9.99999H10V7.99999H19ZM19 0.999992V2.99999H10V0.999992H19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowRightMenuIcon);
export default __webpack_public_path__ + "static/media/show-right-menu-icon.8005ad8b7720d9c42cefcd2b7cb30d5c.svg";
export { ForwardRef as ReactComponent };